import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  loaderContainer: {
    position: "fixed",
    top: 70,
    left: 0,
    bottom: 50,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    zIndex: 9999,
    opacity: 0,
    transition: "opacity 0.5s ease-in-out",
    pointerEvents: "none",
  },
  loaderContainerVisible: {
    opacity: 1,
    pointerEvents: "auto",
  },
}));

const FullscreenLoader = ({ loading }) => {
  const classes = useStyles();
  const [show, setShow] = useState(loading);

  useEffect(() => {
    if (loading) {
      setShow(true);
    } else {
      const timer = setTimeout(() => setShow(false), 500);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (!show) return null;

  return (
    <div
      className={`${classes.loaderContainer} ${
        loading ? classes.loaderContainerVisible : ""
      }`}
    >
      <CircularProgress style={{color:"#0AD172"}} size={50}/>
    </div>
  );
};

export default FullscreenLoader;



// WEBPACK FOOTER //
// ./src/layouts/FullScreenLoader.js